export const DashboardNutritionMealPlan = {
  bindings: {
    mealPlan: '<',
    mealPlanList: '<',
    mealPlansCurrent: '<',
    mealPlansTotal: '<',
    subscriptionId: '<',
  },

  template: `
    <div class="dashboard-nutrition-meal-plan">
      <div class="carousel-mealplan" ng-show="$ctrl.mealPlanList.length">
        <dashboard-carousel>
          <dashboard-carousel-header>
            <h4>{{ $ctrl.mealPlan.title }}</h4>
          </dashboard-carousel-header>
          <dashboard-carousel-body>
            <carousel
              list="$ctrl.mealPlanList">
              <div class="carousel-slide-wrapper"
                ng-class="item.mealsInGroup > 0 ? 'carousel-slide-group carousel-slide-group-' + item.mealsInGroup : ''"
                ng-repeat="item in $ctrl.mealPlanList track by $index">
                <div class="carousel-slide">
                  <div class="completer clearfix">
                    <div class="completer-action">
                      <span class="completer-title text-uppercase pl-2">
                        <span ng-show="item.mealsInGroup">{{ item.dayString }}</span>
                      </span>
                    </div>
                  </div>
                  <card-recipe
                    recipe="item.recipe"
                    is-leftover="item.leftOvers"
                    on-click="$ctrl.stateGo('nutrition.recipes.detail', { recipeId: item.recipeId })">
                  </card-recipe>
                </div>
              </div>
            </carousel>
          </dashboard-carousel-body>
          <dashboard-carousel-footer>
            <a ui-sref="nutrition.mealPlans.detail({ mealPlanId: $ctrl.mealPlan.id})">
              View and edit this plan
            </a>
            <span class="px-sm-2 text-gray">|</span>
            <a ui-sref="nutrition.mealPlans({ type: 'mine' })">My Plans</a>
            <span class="px-sm-2 text-gray">|</span>
            <a ui-sref="nutrition.mealPlans({ type: 'byVoome' })">Ready-made Plans</a>
          </dashboard-carousel-footer>
        </dashboard-carousel>
      </div>
      <div ng-show="!$ctrl.mealPlanList.length && $ctrl.mealPlansCurrent.length">
        <dashboard-carousel>
          <dashboard-carousel-body>
            <carousel list="[1,2,3]">
              <div class="carousel-slide-wrapper"
                ng-repeat="item in $ctrl.mealPlansCurrent track by $index">
                <div class="carousel-slide">
                  <div class="card-book-recipe">
                    <card-book ng-click="$ctrl.stateGo('nutrition.mealPlans.detail', { mealPlanId: item.id })">
                      <left-page>
                        <div class="px-4 pt-2">
                          <i class="fa fa-2x icon-voome-flame text-green"></i>
                          <h1 class="h6">{{ item.title }}</h1>
                          <!-- <p ng-bind="item.description" class="small"></p> -->
                          <p class="small text-muted pb-2 mb-0">
                            {{ item.recipeCount }} meals
                            <meal-plan-tags tags="item.tags" type="diet">|</meal-plan-tags>
                            <meal-plan-tags tags="item.tags">|</meal-plan-tags>
                          </p>
                        </div>
                      </left-page>
                      <right-page>
                        <image-background src="item.heroImage.medium"></image-background>
                      </right-page>
                    </card-book>
                  </div>
                </div>
              </div>
              <div class="carousel-slide-wrapper">
                <div class="carousel-slide">
                  <div class="card-book-empty">
                    <card-book ng-click="$ctrl.stateGo('nutrition.mealPlans')">
                      <left-page>
                        <div class="px-4 text-center">
                          <p class="text-green-dark m-0">
                            View All {{ $ctrl.mealPlansTotal }}
                          </p>
                          <h6 class="text-green-dark">
                            Ready-made Plans
                          </h6>
                        </div>
                      </left-page>
                      <right-page>
                        <i class="fa fa-4x icon-voome-flame text-green"></i>
                      </right-page>
                    </card-book>
                  </div>
                </div>
              </div>
            </carousel>
          </dashboard-carousel-body>
          <dashboard-carousel-footer>
            <a ui-sref="nutrition.mealPlans({ type: 'mine' })">My Plans</a>
            <span class="px-sm-2">|</span>
            <meal-plan-create-button
              style="link"
              subscription-id="$ctrl.subscriptionId">
              Start a new plan
            </meal-plan-create-button>
          </dashboard-carousel-footer>
        </dashboard-carousel>
      </div>
      <div class="carousel-mealplan bg-white text-center p-4" ng-hide="$ctrl.mealPlanList.length">
        You have not selected a meal plan yet.
      </div>
    </div>`,

  controller($state) {
    'ngInject';

    return {
      stateGo: $state.go,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/NutritionMealPlan.js